/*
 * 状态订阅
 */

import store from '../../'

//订阅
export function subscribeEvent ({state, commit, dispatch}, accid) {
  const nim = state.nim
  if (accid) {
    nim.subscribeEvent({
        type: 1,
        accounts: [accid],
        sync: true,
        done: function(error, obj){
          console.log('订阅事件' + (!error?'成功':'失败'), error, obj);
        }
    });
  }
}

//取消订阅
export function unSubscribeEventsByAccounts ({state, commit, dispatch}, accid) {
  const nim = state.nim
  if (accid) {
    nim.unSubscribeEventsByAccounts({
        type: 1,
        accounts: ['cs3'],
        done: function(error, obj) {
            console.log('取消订阅事件' + (!error?'成功':'失败'), error, obj);
        }
    });
  }
}

//发布事件
export function publishEvent ({state, commit, dispatch}, accid) {
  nim.publishEvent({
    type: 1,   //传入1即可。
    value: 10001, //value为10000以上(1-9999为云信预定义值，开发者不可使用)
    sync: false,
    done: function(error, obj) {
      console.log('发布事件' + (!error?'成功':'失败'), error, obj);
    }
  });
}

//订阅事件
export function onPushEvents (param) {
  for(var i in param.msgEvents){
    if(param.msgEvents[i].value == 1){
      if(store.state.nimSDK.onlineList.indexOf(param.msgEvents[i].account)<0){
        store.commit("updateOnlineList",param.msgEvents[i].account)
      }
    }else{
      store.commit("delOnlineList",store.state.nimSDK.onlineList.indexOf(param.msgEvents[i].account))
    }
  }
  console.log("在线列表",store.state.nimSDK.onlineList)
}



// WEBPACK FOOTER //
// ./src/store/modules/nim/subscribeEvent.js